import api from "@/api/api-v2-config";

export async function getLeaveTypeListAxios() {    
    return await api.get("hrms/leavetype?PageNumber=1&PageSize=10000");
}

export async function deleteLeaveTypeAxios(id) {    
    return await api.delete("hrms/leavetype?LeaveTypeId=" + id);
}

export async function postLeaveTypeAxios(leavetype) {    
    return await api.post("hrms/leavetype", leavetype);
}

export async function putLeaveTypeAxios(leavetype) {    
    return await api.put("hrms/leavetype", leavetype);
}

export async function getLeaveTypeByIDAxios(id) {    
    return await api.get("hrms/leavetype/" + id);
}